import { Lab } from 'kb-shared';
import { useSelector } from 'react-redux';
import { ReduxState } from 'redux';

const useHomeMarket = (): Lab => {
  const homeMarket = useSelector<ReduxState>(state => state.patient?.patient?.lab);

  return homeMarket as Lab;
};

export default useHomeMarket;
